var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.76 5.05005H6.76001V7.44005H24.76V5.05005Z",
    fill: "#976332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2999 2.46997H8.95993C8.39108 2.46997 7.92993 2.93112 7.92993 3.49997V5.02997C7.92993 5.59882 8.39108 6.05997 8.95993 6.05997H22.2999C22.8688 6.05997 23.3299 5.59882 23.3299 5.02997V3.49997C23.3299 2.93112 22.8688 2.46997 22.2999 2.46997Z",
    fill: "#B27033"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5501 27.5699H9.00006L8.06006 7.43994H23.7301L22.5501 27.5699Z",
    fill: "#B27033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3001 2.46993H10.1501C10.0962 2.59635 10.069 2.73252 10.0701 2.86993V3.18993C10.0701 3.47371 10.1828 3.74587 10.3835 3.94653C10.5842 4.1472 10.8563 4.25993 11.1401 4.25993H23.2101H23.3201V3.48993C23.3228 3.35524 23.2983 3.22138 23.248 3.0964C23.1977 2.97141 23.1227 2.85788 23.0274 2.76262C22.9321 2.66736 22.8186 2.59232 22.6936 2.54203C22.5687 2.49173 22.4348 2.46721 22.3001 2.46993Z",
    fill: "#F2A156"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3501 25.9299H19.1401C16.6309 25.922 14.2268 24.9218 12.4525 23.1475C10.6782 21.3732 9.67797 18.9691 9.67006 16.4599V8.19994C9.67006 7.94994 9.67006 7.69994 9.67006 7.43994H8.06006L9.00006 27.5699H22.5501L22.6801 25.3099C21.6177 25.7198 20.4888 25.93 19.3501 25.9299Z",
    fill: "#976332"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8999 28.4499C23.4297 28.4499 24.6699 27.2097 24.6699 25.6799C24.6699 24.1501 23.4297 22.9099 21.8999 22.9099C20.3701 22.9099 19.1299 24.1501 19.1299 25.6799C19.1299 27.2097 20.3701 28.4499 21.8999 28.4499Z",
    fill: "#293B58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 26.8999C22.5186 26.8999 23.02 26.3985 23.02 25.7799C23.02 25.1614 22.5186 24.6599 21.9 24.6599C21.2815 24.6599 20.78 25.1614 20.78 25.7799C20.78 26.3985 21.2815 26.8999 21.9 26.8999Z",
    fill: "#CAD0D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.77 5.05005H10.49V6.07005H24.77V5.05005Z",
    fill: "#B27033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash5);
export default __webpack_public_path__ + "static/media/trash5.4dbe7243342089a762b4cf9df8f6f77a.svg";
export { ForwardRef as ReactComponent };